'use client';

import React, { createContext, ReactNode, useContext } from 'react';

import { DomainConfigurationDto } from '@/types/DomainConfigurationDto';

interface DomainConfigurationProviderProps {
    domainConfiguration: DomainConfigurationDto;
    children: ReactNode;
}

const DomainConfigurationContext = createContext<DomainConfigurationDto | undefined>(undefined);

export const DomainConfigurationProvider: React.FC<DomainConfigurationProviderProps> = ({
    domainConfiguration,
    children
}) => {
    return (
        <DomainConfigurationContext.Provider value={domainConfiguration}>
            {children}
        </DomainConfigurationContext.Provider>
    );
};

export const useDomainConfiguration = (): DomainConfigurationDto => {
    const context = useContext(DomainConfigurationContext);
    if (context === undefined) {
        throw new Error('useDomainConfiguration must be used within a DomainConfigurationProvider');
    }
    return context;
};
